export default __webpack_public_path__ + "static/media/behaviour.34c79b71.svg";